<template>
  <div class="wrap categoryList">
    <div class="header">
      <NavBar
        :title= title
        left-arrow
        @click-left="$router.go(-1)"
        class="no_bg"
      ></NavBar>
    </div>
    <div class="main">
      <div class="listBox" >
        <div class="listScroll">
          <div
            class="listItem"
            v-for="item in list"
            :key="item.productId"
          >
            <div @click="toElseDetal(item)">
              <div class="imgBox2">
                <VanImage
                  :src="toPicProductImg(item.productFileEntity.mainImg)"
                  lazy-load />
              </div>

                <!-- 联盟商品 -->
                <!-- <div class="PriceBox" v-if="item.parUnion == 0">
                  <span class="discountPrice" >${{ item.discountPrice }}</span>
                  <span class="nomalPrice">${{ item.nomalPrice }}</span>
                </div> -->
                <!-- 非联盟商品 -->
                <!-- <div class="PriceBox" v-else>
                  <span class="discountPrice" >${{ item.nomalPrice }}</span>
                </div> -->

              <div class="listText" v-if="item.parUnion == 0">
                <div class="productName"><span>{{ item.productName }}</span></div>
                <div class="PriceBox">
                  <span class="discountPrice" >${{ item.discountPrice }}</span>
                  <span class="nomalPrice" >${{ item.nomalPrice }}</span>
                </div>
              </div>
              <div class="listText" v-else>
                <div class="productName"><span>{{ item.productName }}</span></div>
                <div class="PriceBox">
                  <span class="discountPrice" >${{ item.nomalPrice }}</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>
<script>
import request from "../../api/request";
import { toPicProductImg } from "../../utils/common";
export default {
  data() {
    return {
      title:'',
      likeData:{productEntityList:[]},
      list:[]
    }
  },
  created() {
    this.getItem();
  },
  methods:{
    toPicProductImg,
    getItem() {
      let data = { categoryId : this.$route.query.categoryId};
      request("get", "cms/category/queryProductByCategoryId", data).then(res => {
        if (res.code === 200) {
          this.title = res.data.categoryName || 'null'
          this.list = res.data.productEntityList
        }
      });
    },
    toElseDetal(item){
      this.$router.push({
        path: "/productItem",
        query: {
          id: item.productId
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
  .listBox {
    overflow: hidden;
    .listBoxTitle {
      font-size: 15px;
      font-weight: bold;
      padding: 0 0 10px 10px;
      text-align: left;
    }
    .listScroll {
      // width: 100%;
      display: flex;
      overflow: scroll;
      margin-bottom: 20px;
      margin-top: 10px;
      padding: 0 20px;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .listItem {
      text-align: left;
      // margin-left: 10px;
      width: 144px;
      margin-bottom: 20px;
      .listText {
        padding-left: 5px;
        .productName{
          font-size: 16px;
          font-weight: bold;
        }
        .PriceBox{
          font-size: 15px;
          .discountPrice{
            color: red;
          }
          .nomalPrice{
            padding-left:10px;
            text-decoration:line-through
          }
        }
      }
      .imgBox2 .van-image {
        width: 144px;
        height: 144px;
        img {
          width: 100%;
          max-height: 100%;
        }
      }
    }
  }
</style>